import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NewsComponent } from '@login/news/news.component';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-service-unavailable-info',
  imports: [TranslateModule, SvgIconComponent, NewsComponent, SharedModule],
  templateUrl: './service-unavailable-info.component.html',
  styleUrls: [
    '../login-page/login.component.scss',
    '../news/news.component.scss',
    './service-unavailable-info.component.scss',
  ],
})
export class ServiceUnavailableInfoComponent {
  public unavailableService = input<UnavailableService>();
}

export type UnavailableService = 'Backend' | 'CDC';
